import { motion } from 'framer-motion'

const partners = [
  { name: 'Proteor', src: '/images/partners/proteor.svg' },
  { name: 'ALPS', src: '/images/partners/alps.svg' },
  { name: 'Ottobock', src: '/images/partners/ottobock.svg' }
]

const Partners = () => {
  return (
    <section className="border-y border-slate-200 bg-[#fbfcfa] py-14" aria-labelledby="partners-title">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <p className="text-sm font-semibold uppercase tracking-[0.24em] text-teal-700">
            Our Partners
          </p>
          <h2 id="partners-title" className="mt-3 text-2xl font-semibold text-slate-950">
            Trusted names in rehabilitation and prosthetics
          </h2>
        </motion.div>

        <div className="mt-10 grid items-center gap-6 md:grid-cols-3">
          {partners.map((partner, index) => (
            <motion.div
              key={partner.name}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.45, delay: index * 0.08 }}
              viewport={{ once: true }}
              className="flex h-32 items-center justify-center rounded-lg border border-slate-200 bg-white px-8 py-5"
            >
              <img src={partner.src} alt={partner.name} className="max-h-24 w-full object-contain" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Partners
